export const ROLE_INTERNAL_EMPLOYEE = 'ROLE_INTERNAL_EMPLOYEE';
export const ROLE_INTERNAL_ADMIN = 'ROLE_INTERNAL_ADMIN';
export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
export const hasRole = (user, role) => {
    if (!user?.roles) {
        return false;
    }
    return user.roles.includes(role);
};
export const isInternalEmployee = (user) => hasRole(user, ROLE_INTERNAL_EMPLOYEE);
export const isInternalAdmin = (user) => hasRole(user, ROLE_INTERNAL_ADMIN);
